import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import { AdminMenuLayout, ModalBrands } from "../../../shared/components";
import { WrapperCardBrands } from "./styled";
import { useBrands } from "../hooks";
import { selectModalBrands } from "../../../redux";
import { TableBrands } from "./TableBrands";

export const Brands = () => {
  const modalBrands = useSelector(selectModalBrands);
  const {
    isUpdateBrand,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalBrandsState,
  } = useBrands();

  return (
    <AdminMenuLayout pageDescription="Brands" title="Brands">
      <WrapperCardBrands>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalBrandsState}
            >
              Agregar nueva marca
            </Button>
          </Col>
        </Row>
        <TableBrands />
        {modalBrands && isUpdateBrand && (
          <FormProvider {...formMethodsUpdate}>
            <ModalBrands />
          </FormProvider>
        )}
        {modalBrands && !isUpdateBrand && (
          <FormProvider {...formMethodsCreate}>
            <ModalBrands />
          </FormProvider>
        )}
      </WrapperCardBrands>
    </AdminMenuLayout>
  );
};
